import { render, staticRenderFns } from "./ParameterItem.vue?vue&type=template&id=7473c420&scoped=true&"
import script from "./ParameterItem.vue?vue&type=script&lang=js&"
export * from "./ParameterItem.vue?vue&type=script&lang=js&"
import style0 from "./ParameterItem.vue?vue&type=style&index=0&id=7473c420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7473c420",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7473c420')) {
      api.createRecord('7473c420', component.options)
    } else {
      api.reload('7473c420', component.options)
    }
    module.hot.accept("./ParameterItem.vue?vue&type=template&id=7473c420&scoped=true&", function () {
      api.rerender('7473c420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/ParameterItem.vue"
export default component.exports